import { isAbTestVariant, getAbTestTrackingData } from 'dibs-buyer-layout/exports/clientABTestHelpers';
import tracking from 'dibs-tracking';

export const showPdpTileTest = isClient =>
    isClient ? isAbTestVariant(document.cookie, 'PDP_YMAL_TILES') : false;

export const getPdpTileTestVariables = (canRunPdpTileTest, isClient) => {
    if (!canRunPdpTileTest) {
        return {};
    }
    return { filterOutLessSellableItemsTest: showPdpTileTest(isClient) };
};

export const trackPdpTileTest = (canRunPdpTileTest, vertical, isNewAndMadeToOrder) => {
    if (canRunPdpTileTest && vertical !== 'fashion' && !isNewAndMadeToOrder) {
        const trackingData = getAbTestTrackingData(document.cookie, 'PDP_YMAL_TILES');
        tracking.trackAbTestEvent(trackingData, 'pdp');
    }
};
